/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportGenerationAuditDto { 
    creationTime?: string;
    dateRangeEnd?: string;
    dateRangeStart?: string;
    emailId?: number;
    errorMessage?: string;
    exportType?: string;
    id?: number;
    merchantId?: number;
    merchantName?: string;
    recipientEmails?: string;
    reportCode?: string;
    status?: string;
    triggerType?: string;
    triggeredByName?: string;
    triggeredByUserId?: number;
    userShiftId?: number;
}

